var _rect, _rect2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtmCostIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.413793,
    y: 0.413793,
    width: 23.1724,
    height: 23.1724,
    rx: 11.5862,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.413793,
    y: 0.413793,
    width: 23.1724,
    height: 23.1724,
    rx: 11.5862,
    stroke: "#0073EA",
    strokeWidth: 0.827586
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0017 16.928C11.6318 16.928 11.332 16.6282 11.332 16.2583V7.74154C11.332 7.37163 11.6318 7.0719 12.0017 7.0719C12.3716 7.0719 12.6713 7.37163 12.6713 7.74154V16.2583C12.6713 16.6282 12.3716 16.928 12.0017 16.928Z",
    fill: "#0073EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2567 12.6696H7.73996C7.37004 12.6696 7.07031 12.3699 7.07031 12C7.07031 11.6301 7.37004 11.3303 7.73996 11.3303H16.2567C16.6267 11.3303 16.9264 11.6301 16.9264 12C16.9264 12.3699 16.6267 12.6696 16.2567 12.6696Z",
    fill: "#0073EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtmCostIcon);
export default __webpack_public_path__ + "static/media/utm-cost-icon.597b7cc8a9f955ec0e91581bfbfee3c1.svg";
export { ForwardRef as ReactComponent };